<template>
  <b-container class="d-flex align-items-center justify-content-center">
    <div id="login-main" class="spnod-admin__form--main d-flex align-items-center flex-column">
      <h3 class="h3 mb-4">Order Complete</h3>
      <p class="text-center mb-5">Thank you for your payment! You now have full access to speak with a SPNOD Nutritionist!</p>
      <b-button class="spnod-admin__form--button" type="submit" size="sm" @click="confirm()">Continue</b-button>
    </div>
  </b-container>
</template>

<script>
export default {
  name: 'PaymentSuccess',
  data () {
    return {
      title: 'Order Complete'
    }
  },
  methods: {
    confirm() {
      const redirect = this.$route.query.redirect
      if (!redirect) return this.$router.push('/user')
      switch (redirect) {
        case 'group':
          this.$router.push('/group/users')
          break
        case 'user':
          this.$router.push('/user')
          break
        case 'messages':
          this.$router.push('/messages')
          break
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/app/Pages/AdminAuth/PaymentSuccess.vue?2efb6aa8